<form *ngIf="form" [formGroup]="form" (ngSubmit)="createEntity()">
  <dx-lookup [gsResource]="products"
  formControlName="productId"
  displayExpr="name"
  valueExpr="id"
  formField required
  [createComponent]="createProduct"
></dx-lookup>
<dx-text-box formControlName="batch" formField></dx-text-box>
<dx-text-box formControlName="providerBatch" formField></dx-text-box>
<dx-text-box formControlName="barcode" formField/>
<dx-date-box formControlName="expirationDate" formField></dx-date-box>
<dx-lookup
  [gsResource]="productBatchStates"
  formControlName="productBatchStateId"
  displayExpr="name"
  valueExpr="id"
  formField
  [placeholder]="'entity.batch.productBatchStateId' | translate | ucfirst"
></dx-lookup>
</form>